import type { FC } from 'react';
import { lazy } from 'react';
import { Route } from 'react-router-dom';
import {
  useSuperBundleServiceRoot,
  type SuperBundleServiceRequest,
} from 'src/apis/super-bundle-service/use-super-bundle-service-root';
import { EmptyCard } from 'src/components/data-display/empty-card';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { PageHeader } from 'src/components/layout/page-header';
import { Link } from 'src/components/navigation/link';
import { RootRoutes } from 'src/components/root-routes';
import { PageSpinner } from 'src/components/spinner-container';
import type { Successful } from 'src/hooks/use-axios';
import { useTitle } from 'src/hooks/use-title';

const Page = lazy(() => import('./page'));

export const SuperBundleAllocations: FC = () => {
  const superBundleRoot = useSuperBundleServiceRoot();

  if (!superBundleRoot.response) return <PageSpinner />;

  return (
    <RootRoutes>
      <Route
        path="/reporting/super-bundle"
        element={<Allocations superBundleRoot={superBundleRoot} />}
      />
      <Route path="*" element={<ThrowNotFound />} />
    </RootRoutes>
  );
};
export const Allocations: FC<{
  superBundleRoot: Successful<SuperBundleServiceRequest>;
}> = ({ superBundleRoot }) => {
  const title = 'Super Bundle Allocations';
  useTitle(title);

  return (
    <div
      className={`
        grid items-center gap-md
        legacy:gap-[1rem]
      `}
    >
      <PageHeader
        title={title}
        actions={
          <div
            className={`
              grid grid-flow-col items-center justify-between gap-xl
              legacy:gap-[2rem]
            `}
          >
            <p>
              The ongoing offer can be found in the{' '}
              <Link
                mode="default-underlined"
                data-testid="super-bundle-overview-link"
                to={{
                  pathname: `/transport/super-bundle/`,
                }}
              >
                Super Bundle section
              </Link>
              .
            </p>
          </div>
        }
      />

      {superBundleRoot.response.data._links.getAllocations ? (
        <Page url={superBundleRoot.response.data._links.getAllocations.href} />
      ) : (
        <EmptyCard
          data-testid="no-allocations-text"
          label="There are no allocations to show."
        />
      )}
    </div>
  );
};
